import React from "react";
import { TopBar } from "./TopBar";
import { BottomNav } from "./BottomNav";

export function AppShell({ children, hideTopBar = false }) {
  return (
    <div className="relative min-h-screen flex flex-col bg-background text-foreground">
      {!hideTopBar && <TopBar />}
      <main className="flex-1 min-w-0 pb-20 md:pb-0">{children}</main>
      <BottomNav />
    </div>
  );
}
